import { render } from "./VehicleDrawerFlow.vue?vue&type=template&id=6b667bda"
import script from "./VehicleDrawerFlow.vue?vue&type=script&lang=js"
export * from "./VehicleDrawerFlow.vue?vue&type=script&lang=js"
script.render = render

export default script